var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgE5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #21409a;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        stroke: #21409a;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 21,
    cy: 21,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.06,13.12h-7.42l-.89,5.06c1.48-.79,2.84-1.19,4.09-1.19,1,0,1.94,.19,2.8,.56s1.63,.89,2.29,1.55,1.17,1.45,1.55,2.35,.56,1.88,.56,2.92c0,1.51-.34,2.88-1.02,4.12s-1.65,2.22-2.93,2.95-2.75,1.09-4.41,1.09c-1.87,0-3.38-.34-4.54-1.03s-1.98-1.48-2.47-2.37-.73-1.67-.73-2.34c0-.41,.17-.79,.51-1.16s.76-.55,1.27-.55c.88,0,1.53,.51,1.95,1.52,.42,.93,.98,1.65,1.69,2.16s1.5,.77,2.38,.77c.8,0,1.51-.21,2.11-.62s1.07-.99,1.4-1.72,.49-1.56,.49-2.48c0-1-.18-1.85-.53-2.56s-.83-1.24-1.42-1.59-1.26-.52-1.98-.52c-.9,0-1.54,.11-1.92,.33s-.94,.6-1.66,1.15-1.32,.82-1.79,.82c-.51,0-.96-.19-1.36-.55s-.59-.79-.59-1.26c0-.05,.06-.41,.17-1.06l1.31-7.48c.15-.9,.42-1.55,.81-1.95s1.04-.61,1.94-.61h8.25c1.62,0,2.44,.62,2.44,1.86,0,.54-.2,.98-.59,1.31s-.98,.5-1.75,.5Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgE5);
export default __webpack_public_path__ + "static/media/E5.25828a176cb15d920c20d9a96139c3a9.svg";
export { ForwardRef as ReactComponent };